import { message } from "antd";
import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";

import CustomLoader from "../../common/customLoader";
import InternalErrorRcaDetails from "./internalErrorRcaDetails";
import "./internalErrorRcaView.css";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import { useDispatch } from "react-redux";
import { fetchInternalErrorRcaDetailThunk } from "../../../store/thunks/internalErrorRcaThunk";
import { useSelector } from "react-redux";

const InternalErrorRcaView = () => {
  const dispatch = useDispatch();
  const { detail, loading } = useSelector((state) => state.qmsInternalErrorRca);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const location = useLocation();

  const { id } = useParams();

  const prevData = location?.state;

  useEffect(() => {
    if (!id) return;
    dispatch(fetchInternalErrorRcaDetailThunk({ id }))
      .unwrap()
      .then((response) => {
        setGlobalState((prev) => ({
          ...prev,
          eDetails: response,
          eListingPrevData: prevData,
        }));
      })
      .catch((err) => {
        message.error(err?.message || "Failed to fetch escalation details");
      });
  }, [id]);

  const divStructure = (
    <>
      Escalations: {globalState?.eDetails?.transaction_id} From{" "}
      {globalState?.eDetails?.client?.name}
    </>
  );

  return (
    <div className="single-page">
      <CustomLoader showLoader={loading} />
      <TopContainerHeader
        sectionTitle="Internal Error RCA"
        sectionDescription={divStructure}
        hasSectionButton={false}
        sectionButtons={[]}
        hasFilter={false}
        buttonTitle="Add New"
      />
      <InternalErrorRcaDetails />
    </div>
  );
};
export default InternalErrorRcaView;
